import { Receipt, Transaction } from '@/types/payments';
import { addDays, subDays } from 'date-fns';

// Mock Receipts Data
export const generateMockReceipts = (): Receipt[] => {
  return [
    // TEST RECEIPT FOR PROMISE TO PAY (Phase 2)
    {
      id: 'receipt-001',
      receiptNumber: 'RCP-2025-001',
      customerId: 'customer-001',
      customerName: 'ABC Company Ltd',
      customerAccountNumber: 'ACC-001',
      receiptDate: new Date('2025-01-15'),
      receivedAmount: 1250.00,
      allocatedAmount: 0,
      unappliedAmount: 1250.00,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BACS-12345',
      bankReference: 'REF-2025-001',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FS-001',
      importedAt: new Date('2025-01-15'),
      createdBy: 'system',
      createdAt: new Date('2025-01-15'),
      notes: 'Payment received via bank transfer - MATCHES PROMISE',
      hasPromise: true,
      promiseToPayId: 'promise-001',
    },
    {
      id: 'RCP-001',
      receiptNumber: 'RCP-001',
      customerId: 'CUST-001',
      customerName: 'Acme Corporation Ltd',
      customerAccountNumber: 'ACC-001',
      receiptDate: new Date(),
      receivedAmount: 5000.00,
      allocatedAmount: 0,
      unappliedAmount: 5000.00,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-12345',
      bankReference: 'REF-2025-002',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-001',
      importedAt: new Date(),
      createdBy: 'system',
      createdAt: new Date(),
      hasPromise: false,
    },
    {
      id: 'RCP-002',
      receiptNumber: 'RCP-002',
      customerId: 'CUST-002',
      customerName: 'Tech Solutions Inc',
      customerAccountNumber: 'ACC-002',
      receiptDate: new Date(),
      receivedAmount: 3200.00,
      allocatedAmount: 2000.00,
      unappliedAmount: 1200.00,
      currency: 'GBP',
      paymentMethod: 'credit_card',
      paymentReference: 'CC-67890',
      allocationStatus: 'partially_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-002',
      importedAt: new Date(),
      createdBy: 'system',
      createdAt: new Date(),
      hasPromise: false,
    },
    {
      id: 'RCP-003',
      receiptNumber: 'RCP-003',
      customerId: 'CUST-003',
      customerName: 'Global Retail Shop Inc',
      customerAccountNumber: 'ACC-003',
      receiptDate: subDays(new Date(), 1),
      receivedAmount: 8500.00,
      allocatedAmount: 8500.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-54321',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-003',
      importedAt: subDays(new Date(), 1),
      createdBy: 'system',
      createdAt: subDays(new Date(), 1),
      hasPromise: false,
    },
    {
      id: 'RCP-004',
      receiptNumber: 'RCP-004',
      customerId: 'CUST-004',
      customerName: 'Manufacturing Co Ltd',
      customerAccountNumber: 'ACC-004',
      receiptDate: subDays(new Date(), 2),
      receivedAmount: 12500.00,
      allocatedAmount: 0,
      unappliedAmount: 12500.00,
      currency: 'GBP',
      paymentMethod: 'direct_debit',
      paymentReference: 'DD-11111',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-004',
      importedAt: subDays(new Date(), 2),
      createdBy: 'system',
      createdAt: subDays(new Date(), 2),
      hasPromise: false,
    },
    {
      id: 'RCP-005',
      receiptNumber: 'RCP-005',
      customerId: 'CUST-005',
      customerName: 'Services Group PLC',
      customerAccountNumber: 'ACC-005',
      receiptDate: subDays(new Date(), 3),
      receivedAmount: 7800.00,
      allocatedAmount: 5000.00,
      unappliedAmount: 2800.00,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-99999',
      allocationStatus: 'partially_allocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-005',
      importedAt: subDays(new Date(), 3),
      createdBy: 'system',
      createdAt: subDays(new Date(), 3),
      hasPromise: true,
      promiseToPayId: 'PTP-002',
    },
    {
      id: 'RCP-006',
      receiptNumber: 'RCP-006',
      customerId: 'CUST-006',
      customerName: 'Digital Media Ltd',
      customerAccountNumber: 'ACC-006',
      receiptDate: subDays(new Date(), 5),
      receivedAmount: 4500.00,
      allocatedAmount: 0,
      unappliedAmount: 4500.00,
      currency: 'GBP',
      paymentMethod: 'cheque',
      paymentReference: 'CHQ-12345',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-006',
      importedAt: subDays(new Date(), 5),
      createdBy: 'system',
      createdAt: subDays(new Date(), 5),
      hasPromise: false,
    },
    {
      id: 'RCP-007',
      receiptNumber: 'RCP-007',
      customerId: 'CUST-007',
      customerName: 'Construction Partners Ltd',
      customerAccountNumber: 'ACC-007',
      receiptDate: subDays(new Date(), 7),
      receivedAmount: 15000.00,
      allocatedAmount: 15000.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-77777',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-007',
      importedAt: subDays(new Date(), 7),
      createdBy: 'system',
      createdAt: subDays(new Date(), 7),
      hasPromise: false,
    },
    {
      id: 'RCP-008',
      receiptNumber: 'RCP-008',
      customerId: 'CUST-008',
      customerName: 'Healthcare Systems Inc',
      customerAccountNumber: 'ACC-008',
      receiptDate: subDays(new Date(), 10),
      receivedAmount: 9200.00,
      allocatedAmount: 3000.00,
      unappliedAmount: 6200.00,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-88888',
      allocationStatus: 'partially_allocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-008',
      importedAt: subDays(new Date(), 10),
      createdBy: 'system',
      createdAt: subDays(new Date(), 10),
      hasPromise: false,
    },
  ];
};

// Mock Transactions for Allocation
export const generateMockTransactions = (customerId: string): Transaction[] => {
  const transactions: Record<string, Transaction[]> = {
    // TEST TRANSACTIONS FOR PROMISE TO PAY (Phase 2)
    'customer-001': [
      {
        id: 'txn-001',
        transactionNumber: 'INV-2024-001',
        transactionType: 'invoice',
        customerId: 'customer-001',
        customerName: 'ABC Company Ltd',
        transactionDate: new Date('2024-12-01'),
        dueDate: new Date('2024-12-31'),
        originalAmount: 500.00,
        currentBalance: 500.00,
        currency: 'GBP',
        daysOverdue: 15,
        onDispute: false,
        promisedAmount: 500.00,
        isPromised: true,
      },
      {
        id: 'txn-002',
        transactionNumber: 'INV-2024-002',
        transactionType: 'invoice',
        customerId: 'customer-001',
        customerName: 'ABC Company Ltd',
        transactionDate: new Date('2024-12-05'),
        dueDate: new Date('2025-01-04'),
        originalAmount: 350.00,
        currentBalance: 350.00,
        currency: 'GBP',
        daysOverdue: 11,
        onDispute: false,
      },
      {
        id: 'txn-003',
        transactionNumber: 'INV-2024-003',
        transactionType: 'invoice',
        customerId: 'customer-001',
        customerName: 'ABC Company Ltd',
        transactionDate: new Date('2024-12-10'),
        dueDate: new Date('2025-01-09'),
        originalAmount: 450.00,
        currentBalance: 450.00,
        currency: 'GBP',
        daysOverdue: 6,
        onDispute: false,
        promisedAmount: 450.00,
        isPromised: true,
      },
      {
        id: 'txn-004',
        transactionNumber: 'INV-2024-004',
        transactionType: 'invoice',
        customerId: 'customer-001',
        customerName: 'ABC Company Ltd',
        transactionDate: new Date('2024-12-15'),
        dueDate: new Date('2025-01-14'),
        originalAmount: 275.00,
        currentBalance: 275.00,
        currency: 'GBP',
        daysOverdue: 1,
        onDispute: false,
      },
      {
        id: 'txn-005',
        transactionNumber: 'INV-2024-005',
        transactionType: 'invoice',
        customerId: 'customer-001',
        customerName: 'ABC Company Ltd',
        transactionDate: new Date('2024-12-20'),
        dueDate: new Date('2025-01-19'),
        originalAmount: 300.00,
        currentBalance: 300.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
        promisedAmount: 300.00,
        isPromised: true,
      },
      {
        id: 'txn-006',
        transactionNumber: 'INV-2024-006',
        transactionType: 'invoice',
        customerId: 'customer-001',
        customerName: 'ABC Company Ltd',
        transactionDate: new Date('2024-12-25'),
        dueDate: new Date('2025-01-24'),
        originalAmount: 425.00,
        currentBalance: 425.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
      },
    ],
    'CUST-001': [
      {
        id: 'TXN-001',
        transactionNumber: 'INV-1001',
        transactionType: 'invoice',
        customerId: 'CUST-001',
        customerName: 'Acme Corporation Ltd',
        transactionDate: subDays(new Date(), 45),
        dueDate: subDays(new Date(), 15),
        originalAmount: 2000.00,
        currentBalance: 2000.00,
        currency: 'GBP',
        daysOverdue: 15,
        onDispute: false,
        promisedAmount: 2000.00,
        isPromised: true,
      },
      {
        id: 'TXN-002',
        transactionNumber: 'INV-1015',
        transactionType: 'invoice',
        customerId: 'CUST-001',
        customerName: 'Acme Corporation Ltd',
        transactionDate: subDays(new Date(), 38),
        dueDate: subDays(new Date(), 8),
        originalAmount: 1500.00,
        currentBalance: 1500.00,
        currency: 'GBP',
        daysOverdue: 8,
        onDispute: false,
        promisedAmount: 1500.00,
        isPromised: true,
      },
      {
        id: 'TXN-003',
        transactionNumber: 'INV-1023',
        transactionType: 'invoice',
        customerId: 'CUST-001',
        customerName: 'Acme Corporation Ltd',
        transactionDate: subDays(new Date(), 25),
        dueDate: addDays(new Date(), 5),
        originalAmount: 1500.00,
        currentBalance: 1500.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
        promisedAmount: 1500.00,
        isPromised: true,
      },
      {
        id: 'TXN-004',
        transactionNumber: 'INV-1030',
        transactionType: 'invoice',
        customerId: 'CUST-001',
        customerName: 'Acme Corporation Ltd',
        transactionDate: subDays(new Date(), 20),
        dueDate: addDays(new Date(), 10),
        originalAmount: 3200.00,
        currentBalance: 3200.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
      },
      {
        id: 'TXN-005',
        transactionNumber: 'INV-1035',
        transactionType: 'invoice',
        customerId: 'CUST-001',
        customerName: 'Acme Corporation Ltd',
        transactionDate: subDays(new Date(), 15),
        dueDate: addDays(new Date(), 15),
        originalAmount: 1800.00,
        currentBalance: 1800.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
      },
    ],
    'CUST-002': [
      {
        id: 'TXN-006',
        transactionNumber: 'INV-2001',
        transactionType: 'invoice',
        customerId: 'CUST-002',
        customerName: 'Tech Solutions Inc',
        transactionDate: subDays(new Date(), 50),
        dueDate: subDays(new Date(), 20),
        originalAmount: 2500.00,
        currentBalance: 1200.00,
        currency: 'GBP',
        daysOverdue: 20,
        onDispute: false,
      },
      {
        id: 'TXN-007',
        transactionNumber: 'INV-2010',
        transactionType: 'invoice',
        customerId: 'CUST-002',
        customerName: 'Tech Solutions Inc',
        transactionDate: subDays(new Date(), 30),
        dueDate: new Date(),
        originalAmount: 1800.00,
        currentBalance: 1800.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
      },
      {
        id: 'TXN-008',
        transactionNumber: 'INV-2015',
        transactionType: 'invoice',
        customerId: 'CUST-002',
        customerName: 'Tech Solutions Inc',
        transactionDate: subDays(new Date(), 20),
        dueDate: addDays(new Date(), 10),
        originalAmount: 2200.00,
        currentBalance: 2200.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
      },
    ],
    'CUST-004': [
      {
        id: 'TXN-009',
        transactionNumber: 'INV-4001',
        transactionType: 'invoice',
        customerId: 'CUST-004',
        customerName: 'Manufacturing Co Ltd',
        transactionDate: subDays(new Date(), 60),
        dueDate: subDays(new Date(), 30),
        originalAmount: 5000.00,
        currentBalance: 5000.00,
        currency: 'GBP',
        daysOverdue: 30,
        onDispute: false,
      },
      {
        id: 'TXN-010',
        transactionNumber: 'INV-4010',
        transactionType: 'invoice',
        customerId: 'CUST-004',
        customerName: 'Manufacturing Co Ltd',
        transactionDate: subDays(new Date(), 45),
        dueDate: subDays(new Date(), 15),
        originalAmount: 4500.00,
        currentBalance: 4500.00,
        currency: 'GBP',
        daysOverdue: 15,
        onDispute: false,
      },
      {
        id: 'TXN-011',
        transactionNumber: 'INV-4020',
        transactionType: 'invoice',
        customerId: 'CUST-004',
        customerName: 'Manufacturing Co Ltd',
        transactionDate: subDays(new Date(), 30),
        dueDate: new Date(),
        originalAmount: 3000.00,
        currentBalance: 3000.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
      },
    ],
  };

  return transactions[customerId] || [];
};
